import { isValidElement, type JSX, type ReactNode } from 'react';

export interface IShowProps<T> {
  fallback?: ReactNode;
  when: T | null | undefined;
  children: ReactNode | ((props: T) => ReactNode);
}

export function Show<T>({
  when,
  fallback,
  children,
}: IShowProps<T>): JSX.Element {
  let result: ReactNode;

  if (!when) {
    result = fallback;
  } else {
    result = typeof children === 'function' ? children(when) : children;
  }

  return isValidElement(result) ? result : <>{result}</>;
}
